/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import config from "../../config";
import * as Api from "../Api";

const initialState = {
    loading: false,
    filtersMetaData: {},
    currentProductId: null,
};

export const getFiltersMetaData = createAsyncThunk('toolbeltdata/getFilterMetaData',
    async (productId, { rejectWithValue }) => {
        try {
            const GET_METADATA = `${config.services.ATLAS.apiUrl}/products/${productId}/metadata`;
            return await Api.get(true, GET_METADATA);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }, {
        condition: (productId, { getState }) => {
            const { loading, currentProductId } = getState().filtersMetaData;
            if (loading) return false;
            if (!productId) return false;
            if (productId === currentProductId) return false;
            return true;
        }
    });

const filtersMetaDataSlice = createSlice({
    name: 'filtersMetaData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFiltersMetaData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFiltersMetaData.fulfilled, (state, action) => {
                state.filtersMetaData = action.payload;
                state.currentProductId = action.meta.arg;
                state.loading = false;
            })
            .addCase(getFiltersMetaData.rejected, (state) => {
                state.loading = false;
            });
    }
});


export default filtersMetaDataSlice.reducer;
